import { Navigate } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { useAuth } from '@/contexts/AuthContext';
import { UserRole } from '@/services/apis/users';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

const ProtectedAdminOrCreatorRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const hasAdminAccess = user?.role && [UserRole.ADMIN, UserRole.CREATOR].includes(user.role);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <Spinner size="lg" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin or creator role
  if (!user || !hasAdminAccess) {
    return <Navigate to="/404" replace />;
  }

  // User is authenticated and has admin/creator role, render the protected content
  return <>{children}</>;
};

export default ProtectedAdminOrCreatorRoute;
